import * as React from 'react';

const SvgEmail = (props) => (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M26 0H10C4.47715 0 0 4.47715 0 10V26C0 31.5228 4.47715 36 10 36H26C31.5228 36 36 31.5228 36 26V10C36 4.47715 31.5228 0 26 0Z"
        fill="url(#paint0_linear_30807_5833)"
      />
      <g filter="url(#filter0_d_30807_5833)">
        <path
          d="M6 12C6.01758 11.1872 6.35714 10.4147 6.94406 9.85214C7.531 9.2896 8.3172 8.9831 9.13 8.99999H26.87C27.6828 8.9831 28.469 9.2896 29.0559 9.85214C29.6429 10.4147 29.9824 11.1872 30 12V25C29.9824 25.8128 29.6429 26.5853 29.0559 27.1479C28.469 27.7104 27.6828 28.0169 26.87 28H9.13C8.3172 28.0169 7.531 27.7104 6.94406 27.1479C6.35714 26.5853 6.01758 25.8128 6 25V12Z"
          fill="#FFD8D8"
        />
      </g>
      <g filter="url(#filter1_d_30807_5833)">
        <path
          d="M6 12C6.01758 11.1872 6.35714 10.4147 6.94406 9.85214C7.531 9.2896 8.3172 8.9831 9.13 8.99999H26.87C27.6828 8.9831 28.469 9.2896 29.0559 9.85214C29.6429 10.4147 29.9824 11.1872 30 12V25C29.9824 25.8128 29.6429 26.5853 29.0559 27.1479C28.469 27.7104 27.6828 28.0169 26.87 28H9.13C8.3172 28.0169 7.531 27.7104 6.94406 27.1479C6.35714 26.5853 6.01758 25.8128 6 25V12Z"
          fill="#FFDADA"
        />
      </g>
      <g filter="url(#filter2_d_30807_5833)">
        <path
          d="M6 12C6.01758 11.1872 6.35714 10.4147 6.94406 9.85214C7.531 9.2896 8.3172 8.9831 9.13 8.99999H26.87C27.6828 8.9831 28.469 9.2896 29.0559 9.85214C29.6429 10.4147 29.9824 11.1872 30 12V15L19.863 19.857C19.4423 20.0572 18.9836 20.1647 18.5178 20.1723C18.052 20.1799 17.59 20.0874 17.163 19.901L6 15V12Z"
          fill="url(#paint1_linear_30807_5833)"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_30807_5833"
        x={0}
        y={5.99933}
        width={36}
        height={31.0013}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_30807_5833"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_30807_5833"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_30807_5833"
        x={0}
        y={5.99933}
        width={36}
        height={31.0013}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_30807_5833"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_30807_5833"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_30807_5833"
        x={5}
        y={8.99933}
        width={26}
        height={13.1734}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={0.5} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.909804 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_30807_5833"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_30807_5833"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_30807_5833"
        x1={18}
        y1={-4.97818e-7}
        x2={34.704}
        y2={34.416}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F82600" />
        <stop offset={1} stopColor="#FF7F00" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_30807_5833"
        x1={18}
        y1={8.99933}
        x2={18}
        y2={20.1727}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset={1} stopColor="#FCE2E2" />
      </linearGradient>
      <clipPath>
        <rect width={36} height={36} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgEmail;
